import { render } from "./BannerVariant.vue?vue&type=template&id=98927366"
import script from "./BannerVariant.vue?vue&type=script&lang=js"
export * from "./BannerVariant.vue?vue&type=script&lang=js"

import "./BannerVariant.vue?vue&type=style&index=0&id=98927366&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__